import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskModule } from "./mask.module";
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from "ngx-spinner";
import { CpfCnpjHidePipe } from "../pipes/cpfCnpjHide.pipe";
import { CpfCnpjPipe } from "../pipes/cpfCnpj.pipe";
import { TelefonePipe } from "../pipes/telefone.pipe";
import { CepPipe } from "../pipes/cep.pipe";
import { CurrencyScalePipe } from "../pipes/currency-scale.pipe";
import { ExportDropdownComponent } from "../components/export-dropdown/export-dropdown.component";
import { DialogButtonComponent } from "../components/dialog-button/dialog-button.component";
import { ModuloResumoComponent } from "../components/modulo-resumo/modulo-resumo.component";
import { BannerCropComponent } from "../components/banner-crop/banner-crop.component";
import { PaginaPreviaComponent } from "../components/pagina-previa/pagina-previa.component";
import { ExcelDialogComponent } from "../components/excel-dialog/excel-dialog.component";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    MaskModule,
    EditorModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    CpfCnpjHidePipe,
    CpfCnpjPipe,
    DatePipe,
    TelefonePipe,
    CepPipe,
    CurrencyScalePipe,
    DialogButtonComponent,
    ExportDropdownComponent,
    ModuloResumoComponent,
    BannerCropComponent,
    PaginaPreviaComponent,
    ExcelDialogComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    MaskModule,
    EditorModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    CpfCnpjHidePipe,
    CpfCnpjPipe,
    DatePipe,
    TelefonePipe,
    CepPipe,
    CurrencyScalePipe,
    DialogButtonComponent,
    ExportDropdownComponent,
    ModuloResumoComponent,
    BannerCropComponent,
    PaginaPreviaComponent,
    ExcelDialogComponent
  ],
  providers: []
})
export class SharedModule {
}
